import { useAxios } from '@/context/axiosContext'
import { useRedis } from '@/hooks/useRedis'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import DataTable, { TableColumn } from 'react-data-table-component'
import commonUtils from '@/utils/commonUtils'
import { Button, FormGroup, Input, Label, Select } from '@/components'
import { FlexWrapper } from '@/components/layout/flex/flexWrapper'
import { tableStyles } from '@/styles/dataTable/style'

type TInput = HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement

interface DataRow {
  nttSn: number
  nttSj: string
  regId: string
  updId: string
  regDate: string
  updDate: string
  readngCnt: number
  answerCnt: number
  accessIp: string
  useYn: string
  delYn: string
  adminDelYn: string
  userName: string
  nickName: string
  withDrawYn: string
}

interface SrchData {
  srchOpt: string
  srchStr: string
  rndDt: string
  fdbkType: string
  useYn: string
}

const BlogMgmt: React.FC = () => {
  const axios = useAxios()
  const navigate = useNavigate()
  const location = useLocation()
  const [data, setData] = useState<DataRow[]>([])
  const { getComCodes, getComCodeValue } = useRedis()

  const [srchData, setSrchData] = useState<SrchData>(
    location.state?.srchData || {
      srchOpt: '',
      srchStr: '',
      rndDt: '',
      fdbkType: '',
      useYn: '',
    },
  )

  const [currentPage, setCurrentPage] = useState(location.state?.page || 1)
  const [perPage, setPerPage] = useState(location.state?.perPage || 10)

  const formatDateString = (dateString?: string): string => {
    if (!dateString || dateString.length !== 8) return ''

    const year = dateString.substring(0, 4)
    const month = dateString.substring(4, 6)
    const day = dateString.substring(6, 8)

    return `${year}.${month}.${day}`
  }

  const columns: TableColumn<DataRow>[] = [
    {
      name: 'No.',
      selector: (row) => row.nttSn,
      sortable: true,
      width: '5%',
      center: true,
      cell: (row) => (
        <div style={{ width: '100%', textAlign: 'right' }}>{row.nttSn}</div>
      ),
    },
    {
      name: '제목',
      selector: (row) => row.nttSj,
      sortable: true,
      width: '25%',
    },
    {
      name: '댓글수',
      selector: (row) => row.answerCnt,
      sortable: true,
      center: true,
      width: '5%',
    },
    {
      name: '조회수',
      selector: (row) => row.readngCnt,
      sortable: true,
      center: true,
      width: '5%',
    },
    {
      name: '등록일',
      selector: (row) => commonUtils.formatDate(row.regDate, false),
      sortable: true,
      center: true,
      width: '5%',
    },
    {
      name: '사용여부',
      cell: (row) => getComCodeValue('USE_YN', row.useYn)?.codeNm,
      selector: (row) => row.useYn,
      sortable: true,
      center: true,
      wrap: true,
      width: '10%',
      conditionalCellStyles: [
        {
          when: (row: DataRow) => row.useYn === 'Y',
          style: {
            color: 'red',
          },
        },
      ],
    },
    {
      name: '수정자',
      selector: (row) => row.updId,
      sortable: true,
      center: true,
      wrap: true,
      width: '10%',
    },
    {
      name: '수정일',
      selector: (row) => row.updDate,
      format: (row) => commonUtils.formatDate(row.updDate, false),
      sortable: true,
      center: true,
      wrap: true,
      width: '10%',
    },

    {
      name: '',
      cell: (row) => (
        <>
          <Button
            variant="outlined"
            color="neverbe"
            size="xs"
            onClick={() => handleButtonUpdateClick(row.nttSn)}
          >
            수정
          </Button>
        </>
      ),
      width: '20%',
      sortable: false,
    },
  ]

  useEffect(() => {
    getBlogList()
  }, [])

  const handleSearch = (e: React.ChangeEvent<TInput>) => {
    const { name, value } = e.target

    setSrchData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === 'srchOpt' && value !== 'rndDt' ? { rndDt: '' } : {}),
      ...(name === 'srchOpt' && value === 'rndDt' ? { srchStr: '' } : {}),
    }))
  }

  const handleButtonUpdateClick = async (nttSn: number) => {
    navigate(`/blogMgmt/detail`, {
      state: {
        nttSn: nttSn,
        srchData: srchData,
        page: currentPage,
        perPage: perPage,
      },
    })
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      getBlogList()
    }
  }

  const getBlogList = async () => {
    try {
      // 값이 있는 경우만 필터링
      const params = Object.fromEntries(
        Object.entries(srchData).filter(
          ([_, value]) => typeof value === 'string' && value.trim(),
        ),
      )

      const response = await axios.get('/blogMgmt/list', {
        params,
      })

      const common = response.data.common
      const data = response.data.data
      let listData = undefined
      if (common.resultCode == 'BLOGS0200') {
        listData = data.blogList
      }

      console.log('blogList', listData)
      if (Array.isArray(listData)) {
        setData(listData)
      }
    } catch (error) {
      console.error('Error fetching term list:', error)
    }
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          marginBottom: '10px',
          alignItems: 'center',
          marginTop: '50px',
        }}
      >
        <p style={{ marginLeft: '20px', fontSize: '20px' }}>소통게시판 관리</p>
        <div
          style={{
            marginLeft: 'auto',
            display: 'felx',
            justifyContent: 'center',
          }}
        >
          <div style={{ display: 'flex', gap: '5px' }}>
            <FormGroup>
              <Label htmlFor={'useYn'}>사용여부</Label>
              <div style={{ marginBottom: '5px' }} />
              <Select
                id="useYn"
                name="useYn"
                width="100px"
                onChange={handleSearch}
                value={srchData.useYn}
              >
                <option value="">전체</option>
                {getComCodes('USE_YN').map((item) => (
                  <option key={'useYn' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={'srchOpt'}>검색옵션</Label>
              <div style={{ marginBottom: '5px' }} />
              <Select
                id="srchOpt"
                name="srchOpt"
                width="100px"
                onChange={handleSearch}
                value={srchData.srchOpt}
              >
                <option value="00">전체</option>
                <option value="01">제목</option>
                <option value="02">내용</option>
              </Select>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={'srchStr'}>
                <></>
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <FlexWrapper>
                <Input
                  placeholder="검색어"
                  width="300px"
                  id="srchStr"
                  name="srchStr"
                  value={srchData.srchStr}
                  onChange={handleSearch}
                  onKeyDown={handleKeyDown}
                />
              </FlexWrapper>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={''}>
                <></>
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <FlexWrapper gap="10px">
                <Button
                  onClick={getBlogList}
                  color="neverbe"
                  variant="outlined"
                >
                  검색
                </Button>
              </FlexWrapper>
            </FormGroup>
          </div>
          <div style={{ color: 'red', marginTop: '5px', textAlign: 'right' }}>
            * 옵션 선택 후 검색어 없이 조회 가능
          </div>
        </div>
      </div>
      <DataTable
        columns={columns}
        data={data}
        customStyles={tableStyles}
        paginationDefaultPage={currentPage}
        onChangePage={(page) => setCurrentPage(page)}
        pagination={true}
        paginationPerPage={perPage}
        onChangeRowsPerPage={(page) => setPerPage(page)}
        paginationRowsPerPageOptions={[10, 20, 30, 50, 100, 500]}
        noDataComponent={<>조회결과가 없습니다.</>}
      />
    </>
  )
}

export default BlogMgmt
